/**
 * DrManiCelebration - UX-7, the reveal celebration.
 *
 * Colorful side cannons, a central star burst, then a botanical shower as the
 * results open. canvas-confetti owns the temporary canvas and reduced-motion
 * behavior; cleanup prevents particles leaking into a quiz retake.
 */
import React, { useEffect } from 'react';
import { fireQuizFinale, resetQuizConfetti } from '../../utils/quizConfetti';

const DrManiCelebration: React.FC = () => {
  useEffect(() => {
    fireQuizFinale('dmm');
    return () => resetQuizConfetti();
  }, []);

  return null;
};

export default DrManiCelebration;
